// src/pages/Skills.jsx
import { skills } from '../models/portfolioData';

export default function Skills() {
  return (
    <section className="section" id="skills">
      {/* Compatibility anchor for service */}
      <span id="service" className="block relative -top-24 invisible"></span>
      <div className="container text-center">
        <p className="section-subtitle">What I Do ?</p>
        <h6 className="section-title mb-10">Technical Expertise</h6>

        {/* Detailed Tech Stack breakdown */}
        <div className="text-left">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {skills.map((cat) => (
              <div
                key={cat.category}
                className="bg-white dark:bg-[#1a1a26] border border-gray-200 dark:border-[#272738] rounded p-5 transition-shadow hover:shadow-md"
              >
                <h6 className="font-heading text-primary text-base mb-3 font-semibold">
                  {cat.category}
                </h6>
                <div className="flex flex-wrap gap-2">
                  {cat.items &&
                    cat.items.map((s) => (
                      <span
                        key={typeof s === 'string' ? s : s.name}
                        className="bg-gray-100 dark:bg-[#232334] text-gray-700 dark:text-gray-300 text-xs px-2.5 py-1 rounded border border-gray-200 dark:border-[#2e2e42]"
                      >
                        {typeof s === 'string' ? s : s.name}
                      </span>
                    ))}
                  {cat.tags &&
                    cat.tags.map((t) => (
                      <span
                        key={t}
                        className="bg-gray-100 dark:bg-[#232334] text-gray-700 dark:text-gray-300 text-xs px-2.5 py-1 rounded border border-gray-200 dark:border-[#2e2e42]"
                      >
                        {t}
                      </span>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
